import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, vShow as _vShow, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-28ee451a")

_pushScopeId("data-v-28ee451a")
const _hoisted_1 = { class: "flex items-center gap-2 ml-2" }
const _hoisted_2 = {
  key: 0,
  class: "px-1 rounded font-semibold text-12px bg-pink-lp-200 text-red-lp-1200"
}
const _hoisted_3 = {
  key: 1,
  class: "px-1 rounded font-semibold text-12px bg-yellow-lp-200 text-yellow-lp-100"
}
const _hoisted_4 = {
  key: 2,
  class: "inline-block ml-1"
}
const _hoisted_5 = { class: "space-y-6" }
const _hoisted_6 = { class: "flex gap-y-6 flex-row flex-wrap" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "pr-6" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_8 = { class: "space-y-6" }
const _hoisted_9 = { class: "flex gap-y-6 flex-col" }
const _hoisted_10 = { class: "grid grid-cols-3" }
const _hoisted_11 = { class: "grid grid-cols-3" }
const _hoisted_12 = { class: "grid grid-cols-3" }
const _hoisted_13 = { class: "grid grid-cols-3" }
const _hoisted_14 = { class: "flex flex-wrap gap-2" }
const _hoisted_15 = { class: "pr-6" }
const _hoisted_16 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_17 = { class: "detail-pieces overflow-y-scroll" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "pr-6 space-y-0" }, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_19 = {
  key: 0,
  class: "pb-4 flex flex-row space-x-4 font-semibold text-sm"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("span", null, "Total Bag dengan selisih berat", -1)
const _hoisted_21 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "px-2 py-0.5 font-medium bg-yellow-lp-200 text-yellow-lp-100 rounded-2xl mt-6" }, " Dalam Proses Booking ", -1)
const _hoisted_23 = {
  key: 2,
  class: "mt-2"
}
const _hoisted_24 = { class: "px-2 py-0.5 font-medium bg-red-lp-600 text-red-lp-200 rounded-2xl mt-6" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("hr")
], -1)
const _hoisted_26 = { class: "hidden" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Print = _resolveComponent("Print")!
  const _component_PreviewImagePod = _resolveComponent("PreviewImagePod")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      scrollSidebar: "",
      customClass: "px-0",
      onBack: _ctx.goBack,
      title: _ctx.cargoNo,
      loading: _ctx.isLoading,
      error: _ctx.isError,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData
    }, {
      title: _withId(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.isDg)
            ? (_openBlock(), _createBlock("div", _hoisted_2, " DG "))
            : _createCommentVNode("", true),
          (_ctx.isQuarantine)
            ? (_openBlock(), _createBlock("div", _hoisted_3, " K "))
            : _createCommentVNode("", true),
          (_ctx.isDisputeCargo)
            ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_4, [
                _createVNode(_component_Icons, {
                  name: "kg-dispute",
                  class: "text-red-lp-100",
                  style: {"width":"24px","height":"24px"}
                })
              ], 512)), [
                [
                  _directive_tooltip,
                  'Kargo dengan selisih berat',
                  void 0,
                  { bottom: true }
                ]
              ])
            : _createCommentVNode("", true)
        ])
      ]),
      data: _withId(() => [
        _createVNode("div", _hoisted_5, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail pengiriman'),
            fontSize: 20
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_6, [
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Kota asal'),
              value: _ctx.originCity
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Kota tujuan'),
              value: _ctx.destinationCity
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Tipe kargo'),
              value: _ctx.cargoType
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Kode bandara tujuan'),
              value: _ctx.destinationAirport
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Komoditas kargo'),
              value: _ctx.cargoCommodity
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Produk kargo'),
              value: _ctx.cargoProduct
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('NOG'),
              value: _ctx.nog
            }, null, 8, ["label", "value"]),
            (_ctx.detailData.cargoType === 'plane')
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "w-1/2 capitalize",
                  label: _ctx.$t('SHC'),
                  value: _ctx.shcValue
                }, null, 8, ["label", "value"]))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('No. kargo'),
              value: _ctx.cargoNumberOrBookingRequestId
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: 
              `${
                _ctx.detailData.cargoType === 'plane'
                  ? _ctx.$t('No. penerbangan')
                  : _ctx.$t('No. seri kendaraan')
              }`
            ,
              value: _ctx.vehiclePoliceNumber
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Tanggal keberangkatan'),
              value: _ctx.departureDate
            }, null, 8, ["label", "value"]),
            _createVNode(_component_DataWrapper, {
              class: "w-1/2",
              label: _ctx.$t('Tanggal kedatangan'),
              value: _ctx.arrivalDate
            }, null, 8, ["label", "value"])
          ])
        ]),
        _hoisted_7,
        _createVNode("div", _hoisted_8, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail kargo'),
            fontSize: 20
          }, null, 8, ["label"]),
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Total STT'),
                value: _ctx.totalStt
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Koli kargo'),
                value: _ctx.cargoActualPiece
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_11, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat kotor (STT)'),
                value: _ctx.totalGrossWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat kotor (Timbang ulang)'),
                value: _ctx.totalEstCargoGrossWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat kotor kargo'),
                value: _ctx.totalActualCargoGrossWeight
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat volume (STT)'),
                value: _ctx.totalVolumeWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat volume (Timbang ulang)'),
                value: _ctx.totalEstCargoVolumeWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Berat volume kargo'),
                value: _ctx.totalActualCargoVolumeWeight
              }, null, 8, ["label", "value"])
            ]),
            _createVNode("div", _hoisted_13, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Chargeable weight (STT)'),
                value: _ctx.cargoTotalChargeableWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Chargeable weight (Timbang ulang)'),
                value: _ctx.cargoTotalEstimateChargeableWeight
              }, null, 8, ["label", "value"]),
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('Chargeable weight kargo'),
                value: _ctx.cargoTotalCustomChargeableWeight
              }, null, 8, ["label", "value"])
            ]),
            (_ctx.detailData.photoProof?.length)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  class: "w-1/2",
                  label: _ctx.$t('Bukti Foto perubahan berat')
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_14, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailData.photoProof, (item, index) => {
                        return (_openBlock(), _createBlock("div", {
                          key: index,
                          class: "p-1 rounded-lg bg-gray-lp-1000 w-10 h-10 flex items-center justify-center"
                        }, [
                          _createVNode("img", {
                            src: item,
                            class: "w-full h-full object-cover rounded-lg",
                            alt: `Bukti foto perubahan berat koli ${index + 1}`,
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPreviewPhotoProof = true))
                          }, null, 8, ["src", "alt"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createVNode("div", _hoisted_15, [
          _hoisted_16
        ], 512), [
          [_vShow, _ctx.showDetailKoli]
        ]),
        _withDirectives(_createVNode("div", _hoisted_17, [
          _createVNode(_component_Title, {
            label: _ctx.$t('Detail koli'),
            fontSize: 20,
            class: "mb-6"
          }, null, 8, ["label"]),
          _createVNode(_component_TableV2, {
            data: _ctx.detailData.cargoDimensionCustom,
            columns: _ctx.columnsPieces,
            pagination: _ctx.pagination,
            hidePagination: "",
            borderTop: true,
            isEmpty: true,
            bgHeader: "bg-white",
            infiniteScroll: "",
            pinnedSubstractHeight: "211px",
            groupAction: true,
            isPinnedScrollBottom: ""
          }, null, 8, ["data", "columns", "pagination"])
        ], 512), [
          [_vShow, _ctx.showDetailKoli]
        ]),
        _hoisted_18,
        (_ctx.totalDisputeBagging > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_19, [
              _hoisted_20,
              _createVNode("span", null, _toDisplayString(_ctx.totalDisputeBagging) + "/" + _toDisplayString(_ctx.totalBagging), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: `detail-cargo-detail pb-6 space-y-0 mt-4 ${_ctx.totalDisputeBagging > 0 ? 'pt-4' : ''}`
        }, [
          _createVNode(_component_TableV2, {
            data: _ctx.detailData.detailStt,
            columns: _ctx.columns,
            pagination: _ctx.pagination,
            hidePagination: "",
            borderTop: false,
            bgHeader: "bg-white border-t border-gray-lp-1400",
            borderRowColor: "border-white",
            isBorderOnHeadBgWhite: "",
            isEmpty: _ctx.isSttEmpty,
            emptyMessage: _ctx.$t('Tidak ada STT atau bagging di dalam kargo ini'),
            groupAction: ""
          }, null, 8, ["data", "columns", "pagination", "isEmpty", "emptyMessage"])
        ], 2)
      ]),
      "sub-data": _withId(() => [
        (_ctx.ableToEdit && !_ctx.detailData.cargoStatus)
          ? (_openBlock(), _createBlock(_component_LpButton, {
              key: 0,
              title: _ctx.$t('Ubah'),
              onClick: _ctx.goToEdit,
              outline: "",
              textColor: "red-lp-100",
              iconLeft: "pencil-alt"
            }, null, 8, ["title", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.isAbleToCancel)
          ? (_openBlock(), _createBlock("div", _hoisted_21, [
              _hoisted_22,
              _createVNode(_component_LpButton, {
                class: !_ctx.isButtonAble ? 'block' : 'hidden',
                title: _ctx.$t('Batalkan'),
                onClick: _cache[2] || (_cache[2] = 
            () => {
              _ctx.handlerCancelCargo(_ctx.detailData.id, _ctx.detailData.cargoNumber);
              _ctx.confirmationCancelCargo();
            }
          ),
                outline: "",
                textColor: "red-lp-100",
                customClass: "w-40 mt-6"
              }, null, 8, ["class", "title"])
            ]))
          : _createCommentVNode("", true),
        (
          _ctx.detailData.cargoStatus === 'cancel' ||
            _ctx.detailData.cargoStatus === 'failed'
        )
          ? (_openBlock(), _createBlock("div", _hoisted_23, [
              _createVNode("span", _hoisted_24, _toDisplayString(_ctx.$t("Dibatalkan / Gagal Booking")), 1),
              _createVNode(_component_LpButton, {
                title: _ctx.$t('Booking Ulang'),
                onClick: _cache[3] || (_cache[3] = () => _ctx.handlerModalReBooking(true)),
                customClass: "w-40 mt-6 text-white"
              }, null, 8, ["title"]),
              _createVNode(_component_LpButton, {
                title: _ctx.$t('Hapus'),
                onClick: _cache[4] || (_cache[4] = 
            () => {
              _ctx.handlerDeleteCargo(_ctx.detailData.id, _ctx.detailData.cargoNumber);
              _ctx.confirmationDeleteCargo();
            }
          ),
                outline: "",
                customClass: "w-40 mt-6",
                textColor: "red-lp-100"
              }, null, 8, ["title"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_DataWrapper, {
          label: _ctx.$t('Tanggal dibuat'),
          value: _ctx.createdAt,
          caption: _ctx.createdBy
        }, null, 8, ["label", "value", "caption"]),
        _hoisted_25,
        _createVNode("div", null, [
          _withDirectives(_createVNode(_component_DataWrapper, {
            label: _ctx.$t('Print resi kargo')
          }, {
            default: _withId(() => [
              _createVNode(_component_LpButton, {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (
              _ctx.printLabel(
                _ctx.$route.query?.rc_no ? _ctx.$route.query?.rc_no : _ctx.cargoNo,
                _ctx.$route.query?.rc_no ? 'retry' : ''
              )
            )),
                class: "w-48",
                flat: "",
                iconLeft: "invoice",
                dense: "",
                title: _ctx.$t('Cetak label')
              }, null, 8, ["title"]),
              (_ctx.isAWBLionCargo)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 0,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.printAWBLionCargo(_ctx.cargoNo))),
                    class: "w-48",
                    flat: "",
                    iconLeft: "printer",
                    dense: "",
                    title: _ctx.$t('AWB Lion Cargo')
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.isPti)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 1,
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (
              _ctx.printPti(
                _ctx.$route.query?.rc_no ? _ctx.$route.query?.rc_no : _ctx.cargoNo
              )
            )),
                    class: "w-48",
                    flat: "",
                    iconLeft: "print-pti",
                    dense: "",
                    title: _ctx.$t('Cetak PTI')
                  }, null, 8, ["title"]))
                : _createCommentVNode("", true),
              (_ctx.isSptjElektronik)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 2,
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (
              _ctx.printSPTJElektronik(
                _ctx.$route.query?.rc_no ? _ctx.$route.query?.rc_no : _ctx.cargoNo
              )
            )),
                    class: "w-48",
                    flat: "",
                    iconLeft: "print-sptj",
                    dense: "",
                    title: _ctx.$t('Cetak SPTJ')
                  }, null, 8, ["title"]))
                : (_ctx.isSptj)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 3,
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (
              _ctx.printSPTJ(
                _ctx.$route.query?.rc_no ? _ctx.$route.query?.rc_no : _ctx.cargoNo
              )
            )),
                      class: "w-48",
                      flat: "",
                      iconLeft: "print-sptj",
                      dense: "",
                      title: _ctx.$t('Cetak SPTJ')
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true),
              _createVNode(_component_LpButton, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (
              _ctx.printManifestV2(
                _ctx.$route.query?.rc_no ? _ctx.$route.query?.rc_no : _ctx.cargoNo
              )
            )),
                class: "w-48",
                flat: "",
                iconLeft: "printer",
                dense: "",
                title: _ctx.$t('Cetak manifest kargo')
              }, null, 8, ["title"]),
              _createVNode(_component_LpButton, {
                onClick: _cache[11] || (_cache[11] = ($event: any) => {
              _ctx.downloadManifest(_ctx.detailData.id);
            }),
                class: "w-48",
                flat: "",
                iconLeft: "document-download-outline-grey",
                dense: "",
                title: _ctx.$t('Unduh excel')
              }, null, 8, ["title"])
            ]),
            _: 1
          }, 8, ["label"]), [
            [_vShow, !_ctx.isFromListFailedBooking]
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title", "loading", "error", "errorType", "onTryAgain"]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: () => _ctx.goToReBooking(),
      onClose: () => _ctx.handlerModalReBooking(false),
      title: 
      _ctx.$t('Konfirmasi Booking Ulang Kargo?', {
        cargoNumber: _ctx.detailData.cargoNumber
      })
    ,
      message: _ctx.$t('Pastikan seluruh detail STT sudah benar dan sesuai'),
      image: "badge-confirmation-general",
      textSuccess: _ctx.$t('Proses'),
      textCancel: _ctx.$t('Kembali'),
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.showModalReBooking]
    ]),
    _createVNode("div", _hoisted_26, [
      _createVNode(_component_Print, { ref: "print" }, null, 512)
    ]),
    (_ctx.isPreviewPhotoProof)
      ? (_openBlock(), _createBlock(_component_PreviewImagePod, {
          key: 0,
          data: _ctx.detailData.photoProof,
          onClose: () => _ctx.isPreviewPhotoProof = false
        }, null, 8, ["data", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})